// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function UserInvitationHeader(props) {
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: JsxRuntime.jsx("div", {
                                      className: "h-4 w-4 rounded border-2 border-platinum bg-white"
                                    }),
                                className: "w-1/11"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Email",
                                className: "w-1/4"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Roles",
                                className: "w-1/4"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Status",
                                className: "w-60-px mr-30-px"
                              }),
                          JsxRuntime.jsx("p", {
                                className: "w-1/4"
                              })
                        ],
                        className: "flex font-medium p-4 bg-aquahaze text-aurometalsaurus rounded-lg "
                      }))
            });
}

var make = UserInvitationHeader;

exports.make = make;
/* react/jsx-runtime Not a pure module */
